import React from 'react';
import { Database, TrendingUp, Shield } from 'lucide-react';

const CaseStudies: React.FC = () => {
  return (
    <section id="case-studies" className="py-20 bg-ariyva-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-ariyva-dark mb-4">
            Case Studies
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real-world implementations showcasing our data architecture expertise
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Case Study Cards */}
          <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
            <div className="w-12 h-12 bg-ariyva-electric rounded-lg flex items-center justify-center mb-4">
              <Database className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-ariyva-dark mb-2">
              E-commerce Platform Scaling
            </h3>
            <p className="text-gray-600 mb-4">
              Built a scalable data lake handling 10M+ daily transactions with real-time analytics.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 bg-ariyva-cyan/10 text-ariyva-cyan rounded-full text-sm">
                AWS
              </span>
              <span className="px-3 py-1 bg-ariyva-amber/10 text-ariyva-amber rounded-full text-sm">
                Spark
              </span>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
            <div className="w-12 h-12 bg-ariyva-cyan rounded-lg flex items-center justify-center mb-4">
              <TrendingUp className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-ariyva-dark mb-2">
              Financial Data Pipeline
            </h3>
            <p className="text-gray-600 mb-4">
              Implemented secure, compliant data pipelines for real-time trading analytics.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 bg-ariyva-indigo/10 text-ariyva-indigo rounded-full text-sm">
                Kafka
              </span>
              <span className="px-3 py-1 bg-ariyva-terracotta/10 text-ariyva-terracotta rounded-full text-sm">
                Snowflake
              </span>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
            <div className="w-12 h-12 bg-ariyva-amber rounded-lg flex items-center justify-center mb-4">
              <Shield className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-ariyva-dark mb-2">
              Healthcare Analytics Platform
            </h3>
            <p className="text-gray-600 mb-4">
              Developed HIPAA-compliant analytics platform processing patient data securely.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 bg-ariyva-neural/10 text-ariyva-neural rounded-full text-sm">
                Python
              </span>
              <span className="px-3 py-1 bg-ariyva-circuit/10 text-ariyva-circuit rounded-full text-sm">
                MLflow
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
